import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
  padding: 0 10px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
